import { MyClubCardsPage } from '@sorare/gameplay/src/pages/my-cards/MyClubCardsPage';

import { PageParams } from './__generated__/routeParams';

const FootballMyClubCardsPage = () => {
  return <MyClubCardsPage<PageParams> />;
};
export default FootballMyClubCardsPage;
